import React from "react";
import { YhPageHeader } from "@src/components/YhPageHeader";
import { SearchTypeEnum } from "@src/components/YhPageHeader/Types";
import { useAppModel } from "../appModel";
import { StatusDs } from "@src/types/FmsDs";



export function PageHeader() {
    const {
        searchParam,
        appTypeDs,
        onReset,
        onSearch,
        loadData,
        updateSearchParam,
    } = useAppModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "应用名称",
            fieldName: "name",
            size: "small",
            disabled: false
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "应用状态",
            fieldName: "status",
            size: "small",
            disabled: false,
            options: StatusDs
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "应用类型",
            fieldName: "appTypeCode",
            size: "small",
            disabled: false,
            options: appTypeDs
        },
    ]
    return (
        <YhPageHeader
            title="应用集成"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={onReset}
        />
    );
}